// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"19287a5d","453":"ec45456b","591":"36a84c67","889":"f4fd988f","900":"7a08f43f"}[chunkId] + ".chunk.js";
};